// src/services/api.js
import axios from 'axios';
import { toast } from 'react-toastify';

// Make sure this URL is EXACTLY correct
const API_URL = 'https://demo-site.creativepulse.pk/demo-api';

console.log('API URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000,
});

// Add request interceptor to log requests
api.interceptors.request.use(request => {
  console.log('Making API request to:', request.url);
  return request;
});

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('API Response received:', response.config.url, response.data);
    return response;
  },
  (error) => {
    console.error('API Error:', error.config?.url, error.message);
    if (error.response) {
      console.error('Error data:', error.response.data);
      console.error('Error status:', error.response.status);
    }
    toast.error(error.response?.data?.message || 'Something went wrong!');
    return Promise.reject(error);
  }
);

// Product APIs - FIXED to handle your API response structure
export const getProducts = async (category = '', search = '') => {
  try {
    const params = new URLSearchParams();
    if (category && category !== 'all') params.append('category', category);
    if (search) params.append('search', search);

    const url = `/products.php${params.toString() ? '?' + params.toString() : ''}`;
    console.log('Fetching products from:', url);

    const response = await api.get(url);
    console.log('Raw products response:', response.data);

    // Your API returns data directly, not wrapped in a data property
    // The response.data already contains {success: true, products: [...]}
    if (response.data && response.data.success === true) {
      console.log('Products found:', response.data.products?.length || 0);
      return {
        success: true,
        products: response.data.products || [],
        total: response.data.total || 0
      };
    } else {
      console.log('API returned success false or no products');
      return { success: false, products: [], total: 0 };
    }
  } catch (error) {
    console.error('Error in getProducts:', error);
    return { success: false, products: [], total: 0, error: error.message };
  }
};

export const getFeaturedProducts = async () => {
  try {
    console.log('Fetching featured products...');
    const response = await api.get('/featured-products.php');
    console.log('Raw featured response:', response.data);

    if (response.data && response.data.success === true) {
      return {
        success: true,
        products: response.data.products || []
      };
    } else {
      return { success: false, products: [] };
    }
  } catch (error) {
    console.error('Error in getFeaturedProducts:', error);
    return { success: false, products: [], error: error.message };
  }
};

export const getProductById = async (id) => {
  try {
    const response = await api.get(`/product.php?id=${id}`);
    console.log('Product detail raw response:', response.data);

    // Ensure images is always an array
    if (response.data.success && response.data.product) {
      if (!response.data.product.images || !Array.isArray(response.data.product.images)) {
        if (response.data.product.image) {
          response.data.product.images = [response.data.product.image];
        } else {
          response.data.product.images = [];
        }
      }
    }

    return response.data;
  } catch (error) {
    console.error('Error in getProductById:', error);
    return { success: false, product: null, error: error.message };
  }
};

export const createOrder = async (orderData) => {
  const response = await api.post('/orders.php', orderData);
  return response.data;
};

export const sendContactMessage = async (messageData) => {
  const response = await api.post('/contact.php', messageData);
  return response.data;
};

// Add these functions to your existing api.js

// Get public settings (no auth required)
export const getPublicSettings = async () => {
  try {
    const response = await fetch('https://demo-site.creativepulse.pk/demo-api/public/get-settings.php');
    const data = await response.json();
    return data.success ? data.settings : {};
  } catch (error) {
    console.error('Error fetching settings:', error);
    return {};
  }
};

// Update settings (admin only)
export const updateSettings = async (settings) => {
  try {
    const response = await fetch('https://demo-site.creativepulse.pk/demo-api/admin/update-settings.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(settings)
    });
    const data = await response.json();
    return data.success;
  } catch (error) {
    console.error('Error updating settings:', error);
    return false;
  }
};

// src/services/api.js

// Add this function to your existing api.js file
export const getRelatedProducts = async (productId, categoryId = null) => {
  try {
    let url = `https://demo-site.creativepulse.pk/demo-api/get-related-products.php?product_id=${productId}`;
    if (categoryId) {
      url += `&category_id=${categoryId}`;
    }
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching related products:', error);
    return { success: false, products: [] };
  }
};

export default api;